/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function BulkSelect(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'BulkSelect',
      'aria-hidden': true,
      focusable: false,
      width:  13 * scale,
      height: 12 * scale,
      viewBox: '0 0 13 12',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"d":"M6.433 6.019 11.372.092l1.536 1.28-6.34 7.61L2.585 5 4 3.586zM11 7a.5.5 0 1 1 1 0v3.501C12 11.33 11.331 12 10.504 12H1.496A1.495 1.495 0 0 1 0 10.504V1.496C0 .666.666 0 1.503 0H7.5a.5.5 0 0 1 0 1H1.503A.49.49 0 0 0 1 1.496v9.008c0 .275.221.496.496.496h9.008a.497.497 0 0 0 .496-.499z","fill":"currentColor"}))
}
